import { registerPlugin } from "@capacitor/core";

// File handed to the app via Android "Open with"/share-sheet intents.
// (iOS deliveries arrive as file:// URLs through the appUrlOpen event.)
export type OpenedSharedFile = {
  uri: string;
  name: string;
  mimeType: string;
  size: number;
};

export type FileOpenPlugin = {
  // Cold-start intent captured before the webview attached its listener.
  getPendingFile: () => Promise<{ file?: OpenedSharedFile }>;
  addListener: (
    eventName: "fileOpened",
    listenerFunc: (file: OpenedSharedFile) => void
  ) => Promise<{ remove: () => Promise<void> }>;
};

export const fileOpen = registerPlugin<FileOpenPlugin>("FileOpen");
